const state = {
    user: null
};
const mutations = {
    setUser(state, userInfo){
        localStorage.setItem('web_user', userInfo ? JSON.stringify(userInfo) : '');
        state.user = userInfo
    }
};
const actions = {
    setUser({commit}, userInfo){
        commit('setUser', userInfo);
    }
};
const getters = {
    user(state){
        return state.user
    }
};

export default {
    namespaced:true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/user.js